import Modal from 'react-modal';

const customStyles = {
    overlay: {
        zIndex: 9999,
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    content: {
        padding: '0',
        margin: '0',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        background: '#d8d8d8',
        display: 'block'
    },
};

export default function Modals({children, close, isOpen, label, className}) {
    return <Modal
        isOpen={isOpen}
        onRequestClose={close}
        style={customStyles}
        contentLabel={label}
        preventScroll={true}
        className={className ? className : "modal"}
        ariaHideApp={false}
        >
            {children}
    </Modal>
}